import './styles/index.less'
import './assets/fonts/fonts.css' // Paytone One 字体
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/image-preview/style'
/**
 * 项目使用了 unplugin-vue-components 自动导入插件，只对组件标签有效（如 <van-dialog>）
 * 但对函数式调用（如 showConfirmDialog()）无效，样式会失效，所以需要手动导入样式。
 */

import { createApp } from 'vue'
import App from './App.vue'

// 导入初始化模块
import {
  initVConsole,
  initDisableDevtool,
  initTracker,
  initApm,
  initAgora,
  initAdjust,
  setupPlugins,
  acquireAppLock,
} from '@/init'

// 导入语言同步 composable
import { setupLocaleSync } from '@/composables/useLocaleSync'

// 导入浏览器指纹工具
import { getDeviceFingerprint } from '@/utils/fingerprint'

// 导入 global store
import { useGlobalStore } from '@/stores/global'

import 'github-markdown-css/github-markdown-light.css'

// ============ 应用启动初始化 ============

// 开发工具初始化
initVConsole()
initDisableDevtool()

// 埋点初始化
initTracker()

// Adjust SDK 初始化
initAdjust()

// 初始化浏览器指纹（异步，不阻塞应用启动）
void getDeviceFingerprint()

// 创建 Vue 应用实例
const app = createApp(App)

// 注册所有插件
setupPlugins(app)

// 获取单标签页锁并初始化用户状态（非阻塞且必须在注册插件之后执行，因为里面用到 Store）
acquireAppLock()

// 设置语言同步（必须在注册插件之后，因为需要使用 Store）
setupLocaleSync()

// 获取应用静态配置（必须在注册插件之后，因为需要使用 Store）
useGlobalStore().fetchStaticConfig()

// 初始化 Agora RTC 客户端
initAgora()

// 初始化 APM 性能监控
initApm()

// 挂载应用
app.mount('#app')

// 导出 app 实例供函数式组件使用（如 showVideoInvite）
export { app }
